<button
  [attr.id]="inputId()"
  [attr.data-testid]="testId()"
  [attr.aria-label]="ariaLabel() || null"
  type="button"
  class="or-button"
  (click)="handleClick($event)"
  [ngClass]="buttonClass"
  [type]="type()"
  orbitRipple
  [disabled]="disabled()">
  @if (loading()) {
    <orbit-fa-icon [iconName]="spinnerIcon" [iconSize]="'sm'" [animation]="'spin'" />
  }
  @let iconName = icon();
  @if (iconName) {
    <orbit-fa-icon [iconName]="iconName" />
  }

  @let labelVal = label();
  @if (labelVal) {
    <div class="label">
      {{ labelVal }}
    </div>
  }
</button>
